import { isEmpty } from '../utils/common';
import { createCustomEvent, getFullUrlPath } from '../utils/common';

function WalletStore() {
    const eventTarget = document.createElement('div');
    let walletInfo = {};

    function getWalletInfo() {
        return walletInfo;
    }

    async function getWalletInfofromServer() {
        walletInfo = await Promise.resolve($.ajax({
            url: getFullUrlPath('NewIndex/GetWalletBalance'),
            dataType:　'json',
            method: 'POST',
            data:{TZone:(new Date().getTimezoneOffset() / 60 * -1)}
        }));
        eventTarget.dispatchEvent(createCustomEvent('walletInfoUpdate'));
        return await Promise.resolve('resolve');
    }

    function subscribeWalletInfo(callback) {
        eventTarget.addEventListener('walletInfoUpdate', callback);
        if (isEmpty(walletInfo)) {
            getWalletInfofromServer();
        }
    }

    function unSubscribeWalletInfo(callback) {
        eventTarget.removeEventListener('walletInfoUpdate', callback);
    }

    return Object.freeze({
        getWalletInfo,
        getWalletInfofromServer,
        subscribeWalletInfo,
        unSubscribeWalletInfo
    });
}

export default WalletStore();